module.exports = __webpack_public_path__ + "static/media/ladybird.bfc570cc.png";